export default "__VITE_ASSET__DrBk3zwA__"